module.exports = __webpack_public_path__ + "static/media/levelUpgrade.5158d500.png";